export default __webpack_public_path__ + "static/media/chime.ed520832.ogg";